import React from 'react';

import { panelRow } from './MultiRowPanel.module.scss';

function PanelRow({ classes = {}, children }) {
  return <div className={`${panelRow} ${classes.panelRow}`}>{children}</div>;
}

export default PanelRow;
